import { Business, GridView, Person } from '@mui/icons-material';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';
import React from 'react';

import { WorkspaceType } from '~/scenes/MyWorkspace/data';

type PropsType = SvgIconProps & {
  type: WorkspaceType | string;
};

//TODO: remove if no longer needed
export const WorkspaceTypeIcon = (
  props: PropsType,
): React.ReactElement | null => {
  const { type, ...rest } = props;

  switch (type) {
    case WorkspaceType.Company:
      return <Business {...rest} />;
    case WorkspaceType.Personal:
      return <Person {...rest} />;
    case WorkspaceType.Default:
      return <GridView {...rest} />;
    default:
      return null;
  }
};
